const LabelHelper = {
	applicationStatus(status) {
		switch (status) {
			case 'pending':
				return 'Pending';
			case 'rejected':
				return 'Rejected';
			case 'cancelled':
				return 'Cancelled';
			case 'approved':
				return 'Approved';
			default:
				return '';
		}
	},
	bookerYesOrNo(ans) {
		switch (ans) {
			case 'yes':
				return 'Yes';
			case 'no':
				return 'No';
			default:
				break;
		}
	},
	guestType(type) {
		switch (type) {
			case 'staff':
				return 'Staff';
			case 'vip':
				return 'VIP';
			default:
				break;
		}
	},
	purposeOfTrip(purpose) {
		switch (purpose) {
			case 'business':
				return 'Business';
			case 'local_pickup_deliver':
				return 'Local Pickup / Deliver';
			case 'airport_pickup_deliver':
				return 'Airport Pickup / Deliver';
			case 'other':
				return 'Other';
			default:
				break;
		}
	}
};

export default LabelHelper;
